import { render, staticRenderFns } from "./PromptTemplateEdit.vue?vue&type=template&id=47c272ec&"
import script from "./PromptTemplateEdit.vue?vue&type=script&lang=ts&"
export * from "./PromptTemplateEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PromptTemplateEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VContainer,VForm,VRow,VSpacer})
